import * as React from 'react';
import { Modal, Button, Radio } from 'antd';
import InformReason from './InformReason';
import { tokens } from 'src/design-system';

export default class QuoteConfirmationModal extends React.PureComponent<any, any> {
  state = {
    closeInquiry: '',
    viewInformReason: false,
    remark: ''
  };

  closeInformReason = () => {
    this.setState({
      viewInformReason: false,
    });
  }

  openInformReason = (selectedBid, topRankBid) => {
    this.setState({
      selectedBid,
      topRankBid,
      viewInformReason: true,
    });
  }

  setRemark = (val) => {
    this.setState({ remark: val });
  }

  handleConfirm = (closeInquiry) => {
    const isReasonCapturedEarlier = ((this.props.bidData.id === this.props.inquiryData.confirmedBidId) && (this.props.inquiryData.reasonForNonL1BidConfirmation));
    const isRank1Bid = (this.props.bidData.rank === '1');
    const isReasonRequiredAtConfirmation = this.props.captureReasonForNonL1Bid;
    const reason = isRank1Bid ? null : this.props.inquiryData.reasonForNonL1BidConfirmation;
    if ((isReasonCapturedEarlier && isReasonRequiredAtConfirmation) || (!isReasonCapturedEarlier && !isReasonRequiredAtConfirmation) || isRank1Bid) {
      return this.props.handleOk(closeInquiry, reason)
    } else {
      return this.openInformReason(this.props.selectedBid, this.props.topRankBid)
    }
  }

  handleConfirmBid = () => {
    const { closeInquiry, remark } = this.state;
    this.closeInformReason();
    return this.props.handleOk(closeInquiry, remark);
  }

  render() {
    const { visible, handleOk, handleCancel, loading, options } = this.props;
    const { closeInquiry } = this.state;
    const isDisabled = options && !closeInquiry;

    return (
      <Modal
        title="Quote Confirmation"
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => this.handleConfirm(closeInquiry)}
            loading={loading}
            style={{
              background: isDisabled ? '#999999' : tokens.colors.primary,
              border: tokens.colors.primary,
              color: tokens.colors.bgWhite,
            }}
            disabled={isDisabled}
          >
            Confirm Bid
          </Button>,
        ]}>
        {this.state.viewInformReason &&
          <InformReason
            type={'SHIPPER'}
            booking={false}
            topRankBid={this.props.topBidData}
            selectedBid={this.props.bidData}
            currencySymbols={this.props.currencySymbols}
            visible={this.state.viewInformReason}
            handleCancel={this.closeInformReason}
            handleConfirmBid={this.handleConfirmBid}
            setRemark={this.setRemark}
            heading="Reason"
            mode={this.props?.inquiryData?.mode??'FCL'} />}
        {options ? (
          <p>Please choose one of the following in order to proceed with the bid confirmation:</p>
        ) : (
          <p>Are you sure, you want to confirm the quote?</p>
        )}
        <Radio.Group
          onChange={(e) => this.setState({ closeInquiry: e.target.value })}
          value={closeInquiry}
        >
          {options?.map((option) => (
            <Radio key={options.key} value={option.key} style={{marginTop: '10px', fontSize: `${tokens.fontSize.body}px`}}>
              {option.label}
            </Radio>
          )) || []}
        </Radio.Group>
      </Modal>
    );
  }
}
